<template>
    <div class="tw-ws-table-container" :style="{ position: 'absolute', width: 'auto'}">

        <DataTable class="tw-ws-table" 
        :class="[ 
            size ? 'p-datatable-' + size : '',
            {
                'tw-ws-table_border': showBorder, 
                'tw-ws-table_border_no': !showBorder 
            }
        ]" 
        :value="rollShow ? datas.datas.slice(currentPage*pageSize, (currentPage + 1)*pageSize) : datas.datas.slice(rollNum, pageSize+rollNum)" responsiveLayout="scroll">
            <Column :style="{ 'font-size': `${comFontSize}px`, 'text-align': comTextAlign, width: item.edit_width?`${item.edit_width}px`:'auto'}"
            :headerStyle="{ background: headerBgColor, color: headerColor, display: showHeader?'table-cell':'none' }" 
            :bodyStyle="{ background: rowBgColor, color: rowColor}"
            v-for="item in datas.columns" :key="item.field_name" :field="item.field_name" :header="item.caption">
                <template #body="{data}">
                    <span class="tw-ws-table-body">
                        {{data[item.field_name]}}
                    </span>
                </template>
            ></Column>
        </DataTable>

        <Paginator :totalRecords="datas.datas.length" :rows="pageSize" :first="currentPage * pageSize" v-show="rollShow && showPages"></Paginator>
    </div>
</template>

<script>
import { computed, ref,onMounted, onUnmounted, watchEffect } from "vue";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Paginator from 'primevue/paginator';

export default {
    name: "tw-ws-table",
    components: {
        DataTable,
        Column,
        Paginator
    },
    setup(props) {

        const defaultData = {
            columns: [
                {
                    field_name: "name",
                    caption: "姓名",
                    edit_width: 80
                },
                {
                    field_name: "sex",
                    caption: "性别",
                    edit_width: 80
                },
                {
                    field_name: "age",
                    caption: "年龄",
                    edit_width: 80
                }
            ],
            datas: [
                {
                    name: "小张",
                    sex: "女",
                    age: "21"
                },
                {
                    name: "小林",
                    sex: "男",
                    age: "30"
                },
                {
                    name: "小肖",
                    sex: "男",
                    age: "31"
                },
                {
                    name: "小周",
                    sex: "男",
                    age: "32"
                },
                {
                    name: "小黄",
                    sex: "女",
                    age: "21"
                },
                {
                    name: "小红",
                    sex: "女",
                    age: "23"
                },
                {
                    name: "小明",
                    sex: "男",
                    age: "18"
                },
                {
                    name: "小李",
                    sex: "男",
                    age: "44"
                }
            ]
        }

        var currentPage = ref(0); // 当前页码,从0开始
        var pageSize = ref(props.pageSizes); // 每页的数据条数
        var rollNum = ref(0);   //逐条滚动

        let datas = computed(() => {
            if(props.data_source && (Object.keys(props.data_source)).length > 0){
                if (Array.isArray(props.data_source.columns) && Array.isArray(props.data_source.datas)) {
                    const data_source = props.data_source;

                    if(props.showRank){
                        data_source.columns.unshift({
                            field_name: "id",
                            caption: "",
                            edit_width: 40
                        })
                        data_source.datas.forEach((el,id) => {
                            el['id'] = id + 1
                        });
                    }

                    return data_source
                } else {
                    return {
                        columns: [],
                        datas: []
                    }
                }
            }else{
                const data = defaultData;

                if(props.showRank){
                    data.columns.unshift({
                        field_name: "id",
                        caption: "",
                        edit_width: 40
                    })
                    data.datas.forEach((el,id) => {
                        el['id'] = id + 1
                    });
                }
                return data
            }
        })

        const handleSizeChange = (val) => {
            // console.log(`每页 ${val} 条`);
            currentPage.value = 1;
            pageSize.value = val;
        }

        const handleCurrentChange = (val) => {
            // console.log(`当前页: ${val}`);
            currentPage.value = val;
        }

        const indexMethod = (index) => {
            if(props.rollShow){
                //翻页滚动
                return index + (currentPage.value - 1) * pageSize.value + 1
            }else{
                //逐条滚动
                return index + rollNum.value + 1
            }
        }

        let timer = ref(null);

        onMounted(() => {
            watchEffect(effect)
        })

        const effect = () => {
            if(props.rollShow){ //翻页滚动
                const pageTotal = datas.value.datas.length / pageSize.value;

                if(pageTotal > 1){
                    clearInterval(timer);
                    timer = setInterval(()=>{
                        if(currentPage.value <= Math.ceil(pageTotal)){
                            currentPage.value ++;
                        }else{
                            currentPage.value = 0;
                        }
                        // console.log(currentPage.value, Math.ceil(pageTotal))
                    }, props.rollPeriod * 1000);
                }
            }else{  //逐条滚动
                rollNum.value = 0;
                clearInterval(timer);
                timer = setInterval(()=>{
                    if(rollNum.value < datas.value.datas.length - 1){
                        rollNum.value ++;
                    }else{
                        rollNum.value = 0;
                    }
                }, props.rollPeriod * 1000);
            }
        }

        onUnmounted(() => {
            clearInterval(timer);
        })

        return {
            datas,
            currentPage,
            pageSize,
            handleSizeChange,
            handleCurrentChange,
            indexMethod,
            rollNum
        };
    },
    props: {
        comFontSize: {
            type: Number,
            default: 14
        },
        comTextAlign: {
            type: String,
            default: 'center'
        },
        comHeight: {
            type: Number,
            default: 30
        },
        headerBgColor: {
            type: String,
            default: 'rgba(0,0,0,0)'
        },
        headerColor: {
            type: String,
            default: '#FFFFFF'
        },
        rowBgColor: {
            type: String,
            default: 'rgba(0,0,0,0)'
        },
        rowColor: {
            type: String,
            default: '#FFFFFF'
        },
        showHeader: {
            type: Boolean,
            default: true
        },
        showRank: {
            type: Boolean,
            default: false
        },
        showBorder: {
            type: Boolean,
            default: false
        },
        showPages: {
            type: Boolean,
            default: true
        },
        pageSizes: {
            type: Number,
            default: 5
        },
        rollShow: {
            type: Boolean,
            default: false
        },
        rollPeriod: {
            type: Number,
            default: 10
        },
        data_source: {
            type: Object,
            default: function() {
                return { }
            }
        },
        size: {
            type: String,
            default: "sm"
        }
    }
}
</script>

<style lang="scss">

</style>